<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('DatabaseIntegration_title') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="5">
              <!-- <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="field-search-rowtable-dataIntegration"
                      :label="'Table Name'"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchDataIntegrationName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn id="button-search-rowtable-dataIntegration" color="primary" class="ml-2" variant="elevated" prepend-icon="mdi-magnify" @click="Search"> Search </v-btn>
                  </v-col>
                </v-row>
              </v-card> -->
              <div class="page-title">{{ 'Database Integration List' }}</div>
            </v-col>
            <v-col cols="12" md="7" class="d-flex flex-wrap justify-end gap-2">
              <v-dialog v-model="AddDataIntegration" max-width="800" persistent class="modern-dialog">
                <template v-slot:activator="{ props: activatorProps }">
                  <!-- Search Text Field -->
                  <v-text-field v-model="searchDataIntegrationName" placeholder="Search" variant="outlined" density="comfortable" class="custom-search-field" hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="#001763" size="25">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>

                  <!-- Document Button -->
                  <v-btn v-if="canAdd" variant="elevated" class="custom-document-btn" v-bind="activatorProps" id="button-add-dataIntergration">
                    <v-icon size="23" class="mr-2">mdi-plus</v-icon>
                    <span class="database-text">Database</span>
                  </v-btn>

                  <!-- Filter Button -->
                  <v-btn color="#4B2869" variant="elevated" class="filter-btn" icon @click="toggleFilterDrawer">
                    <v-icon color="white" size="25">mdi-filter-variant</v-icon>
                  </v-btn>

                  <!-- <v-btn
                    id="button-add-dataIntergration"
                    color="primary"
                    class="control-btn create-btn"
                    variant="elevated"
                    size="large"
                    prepend-icon="mdi-plus-circle"
                    rounded="xl"
                    v-bind="activatorProps"
                  >
                    <span class="btn-text">{{ $t('add') }}</span>
                  </v-btn> -->
                </template>

                <v-card class="dialog-card" elevation="0">
                  <!-- Enhanced Header -->
                  <div class="dialog-header dialog-header-add">
                    <div class="header-main">
                      <div class="header-icon-container">
                        <div class="icon-background">
                          <v-icon size="24" color="white">mdi-table-plus</v-icon>
                        </div>
                      </div>
                      <div class="header-text-content">
                        <h2 class="dialog-title">Add New Table</h2>
                        <p class="dialog-subtitle">Configure your data integration table</p>
                      </div>
                    </div>
                    <div class="header-actions">
                      <v-btn icon variant="text" color="white" @click="closeDialogAddDataIntegration" class="close-button">
                        <v-icon size="20">mdi-close</v-icon>
                      </v-btn>
                    </div>
                    <!-- <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <div class="header-content">
                        <div class="header-icon">
                          <v-icon size="24" color="primary"
                            >mdi-table-plus</v-icon
                          >
                        </div>
                        <div class="header-text">
                          <h2 class="title-text">Add New Table</h2>
                          <p class="subtitle-text">
                            Configure your data integration table
                          </p>
                        </div>
                      </div>
                      <v-btn
                        icon
                        variant="text"
                        size="small"
                        @click="AddDataIntegration = false"
                        class="close-btn"
                      >
                        <v-icon size="20">mdi-close</v-icon>
                      </v-btn>
                    </div> -->
                  </div>

                  <v-divider class="header-divider"></v-divider>

                  <v-card-text class="modern-content">
                    <!-- System Type Selection -->
                    <div class="section-container">
                      <div class="section-header">
                        <v-icon size="18" color="primary" class="section-icon">mdi-cog</v-icon>
                        <span class="section-title">{{ $t('system') }}</span>
                      </div>

                      <v-radio-group v-model="requestDataIntegration.Type" inline @update:model-value="ClearPopupWhenChange()" class="radio-group-modern">
                        <div class="radio-options">
                          <v-radio id="radio-I-dataintegration" :label="$t('internal')" value="I" class="radio-option">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon size="16" class="radio-icon">mdi-database</v-icon>
                                {{ $t('internal') }}
                              </div>
                            </template>
                          </v-radio>
                          <v-radio id="radio-E-dataintegration" :label="$t('external')" value="E" class="radio-option">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon size="16" class="radio-icon">mdi-cloud-outline</v-icon>
                                {{ $t('external') }}
                              </div>
                            </template>
                          </v-radio>
                        </div>
                      </v-radio-group>
                    </div>

                    <!-- Internal System Configuration -->
                    <div v-show="requestDataIntegration.Type == 'I'" class="config-section">
                      <div class="section-container">
                        <div class="section-header">
                          <v-icon size="18" color="primary" class="section-icon">mdi-database</v-icon>
                          <span class="section-title">Internal Configuration</span>
                        </div>

                        <div class="form-grid">
                          <div class="form-group form-group-large">
                            <v-text-field
                              id="add-tablename-internal-dataIntegration"
                              label="Table Name"
                              v-model="requestDataIntegration.DataIntegrationName"
                              :rules="[rules.required]"
                              variant="outlined"
                              density="comfortable"
                              class="modern-input"
                            >
                              <template v-slot:append-inner>
                                <v-tooltip text="Table name information" location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" size="16" color="grey-darken-1" class="info-icon"> mdi-help-circle-outline </v-icon>
                                  </template>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </div>
                          <div class="form-group upload-section">
                            <div class="upload-container">
                              <div class="upload-area">
                                <!-- ปุ่มอัปโหลดหลัฝ -->
                                <v-btn id="proxy-upload-button" color="primary" variant="elevated" size="large" prepend-icon="mdi-cloud-upload" @click="triggerFileUpload" class="upload-main-btn">
                                  <span class="upload-text">Upload File</span>
                                </v-btn>

                                <!-- ข้อมูลเพิ่มเติม -->
                                <div class="upload-info">
                                  <div class="upload-description">
                                    <v-icon size="16" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                    <span class="upload-hint">Select Excel file (.xlsx) to upload</span>
                                  </div>

                                  <!-- Tooltip สำหรับข้อมูลเพิ่มเติม -->
                                  <v-tooltip text="Supported format: Excel (.xlsx) files only" location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-btn v-bind="props" icon variant="text" size="small" class="upload-help-btn">
                                        <v-icon size="18" color="grey-darken-1">mdi-help-circle-outline</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-tooltip>
                                </div>

                                <!-- ๝สดงชื่อไฟล์ที่เลือฝ (ถ้ามี) -->
                                <div v-if="uploadedFiles.length > 0" class="uploaded-file-info">
                                  <v-chip color="success" variant="tonal" size="small" prepend-icon="mdi-file-excel" class="file-chip">
                                    {{ uploadedFiles[0].name }}
                                  </v-chip>
                                </div>
                              </div>

                              <!-- DragDropFile ที่ซ่อนไว้ -->
                              <DragDropFile
                                ref="dragDropRef"
                                :dialog="true"
                                :DragDrop="false"
                                :ShowListFile="false"
                                :accept="accept"
                                @filesUploaded="processUpload($event)"
                                :allowType="[]"
                                class="modern-upload hidden-upload"
                                id="add-UploadFile-Internal-DataIntegration"
                              />
                            </div>
                          </div>
                        </div>

                        <!-- Columns Configuration -->
                        <div v-if="requestDataIntegration.Columns.length > 0 && requestDataIntegration.entity != null" class="columns-section">
                          <div class="columns-header">
                            <h3 class="columns-title">Column Configuration</h3>
                            <v-chip size="small" color="primary" variant="tonal">
                              {{ requestDataIntegration.Columns.length }}
                              columns
                            </v-chip>
                          </div>

                          <div class="columns-list">
                            <v-card v-for="(item, index) in requestDataIntegration.Columns" :key="index" class="column-card" variant="outlined">
                              <v-card-text class="column-content">
                                <div class="column-fields">
                                  <v-text-field
                                    :id="`add-columnName-Internal-dataIntegration-${index}`"
                                    :label="$t('_columnDataIntegration')"
                                    v-model="item.name"
                                    variant="outlined"
                                    density="comfortable"
                                    class="column-input"
                                    :error="errorMessages.columns[index]?.error"
                                    :error-messages="errorMessages.columns[index]?.message"
                                  >
                                    <template v-slot:append-inner>
                                      <v-tooltip :text="$t('_columnDataIntegration')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </template>
                                  </v-text-field>

                                  <v-select
                                    :id="`add-dataType-Internal-dataIntegration-${index}`"
                                    :label="$t('_typeDataIntegration')"
                                    :items="DDDataType"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.typeId"
                                    @update:model-value="setDefault(item)"
                                    variant="outlined"
                                    density="comfortable"
                                    class="column-input"
                                  >
                                    <template v-slot:append-inner>
                                      <v-tooltip :text="$t('_typeDataIntegration')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </template>
                                  </v-select>
                                </div>

                                <div class="column-fields">
                                  <v-select
                                    :items="fuzzyOptions"
                                    item-title="text"
                                    item-value="value"
                                    variant="outlined"
                                    class="fuzzy-select"
                                    density="compact"
                                    hide-details
                                    @update:model-value="setFuzzyValue(item, $event)"
                                    :disabled="item.typeId != 'nvarchar' && item.typeId != 'varchar' && item.typeId != 'varchar2' && item.typeId != 'text' 
                                    && item.typeId != 'char' && item.typeId != 'nchar' && item.typeId != 'VARCHAR2' && item.typeId != 'TEXT'
                                    && item.typeId != 'CHAR' && item.typeId != 'NCHAR' && item.typeId != 'NVARCHAR2'"
                                  >
                                    <template v-slot:selection="{ item: selectedItem }">
                                      <div class="selection-content">
                                        <v-icon :color="getFuzzyColor(selectedItem.raw)" size="16" class="mr-2">
                                          {{ getFuzzyIcon(selectedItem.raw) }}
                                        </v-icon>
                                        <span class="selection-text">{{ selectedItem.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item: dropdownItem }">
                                      <v-list-item v-bind="props" class="fuzzy-list-item">
                                        <template v-slot:prepend>
                                          <v-icon :color="getFuzzyColor(dropdownItem.raw)" size="18">
                                            {{ getFuzzyIcon(dropdownItem.raw) }}
                                          </v-icon>
                                        </template>

                                        <v-list-item-subtitle class="fuzzy-item-subtitle">
                                          {{ dropdownItem.raw.description }}
                                        </v-list-item-subtitle>
                                      </v-list-item>
                                    </template>

                                    <template v-slot:label>
                                      <div class="label-content">
                                        <v-icon size="16" class="mr-2" color="primary">mdi-tune</v-icon>
                                        <span>Fuzzy Matching</span>
                                      </div>
                                    </template>
                                  </v-select>

                                  <div class="personal-info-wrapper">
                                    <div class="personal-info-container">
                                      <div class="personal-info-header">
                                        <v-tooltip location="top" max-width="300px">
                                          <template v-slot:activator="{ props }">
                                            <div class="personal-info-label" v-bind="props">
                                              <v-icon size="16" color="warning" class="mr-1">mdi-shield-account</v-icon>
                                              <span class="text-caption">
                                                Personal Info:
                                                <span :class="item.personalInformation ? 'status-on' : 'status-off'">
                                                  {{ item.personalInformation ? 'ON' : 'OFF' }}
                                                </span>
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ $t('_Personal_Info') }}</span>
                                        </v-tooltip>

                                        <v-switch
                                          v-model="item.personalInformation"
                                          inset
                                          density="compact"
                                          color="warning"
                                          hide-details
                                          class="personal-info-switch"
                                          :disabled="
                                            item.typeId != null &&
                                            item.typeId.toLowerCase() != 'nvarchar' &&
                                            item.typeId.toLowerCase() != 'text' &&
                                            item.typeId.toLowerCase() != 'varchar' &&
                                            item.typeId.toLowerCase() != 'varchar2' &&
                                            item.typeId.toLowerCase() != 'char' &&
                                            item.typeId.toLowerCase() != 'nchar'
                                          "
                                        ></v-switch>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <v-checkbox
                                    :id="`add-checkbox-fuzzy-dataIntegration-${index}`"
                                    v-model="item.fuzzy"
                                    @update:model-value="item.fuzzyBot = false"
                                    :disabled="item.typeId != 'nvarchar'"
                                    label="Fuzzy"
                                    color="primary"
                                    density="comfortable"
                                    hide-details
                                    class="modern-checkbox"
                                  ></v-checkbox>

                                  <v-checkbox
                                    :id="`add-checkbox-fuzzybot-dataIntegration-${index}`"
                                    v-model="item.fuzzyBot"
                                    @update:model-value="item.fuzzy = false"
                                    :disabled="
                                      requestDataIntegration.Type == 'I' &&
                                      item.typeId != 'nvarchar'
                                    "
                                    label="Fuzzy with bot"
                                    color="primary"
                                    density="comfortable"
                                    hide-details
                                    class="modern-checkbox"
                                  ></v-checkbox> -->
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- External System Configuration -->
                    <div v-show="requestDataIntegration.Type == 'E'" class="config-section">
                      <div class="section-container">
                        <div class="section-header">
                          <v-icon size="18" color="primary" class="section-icon">mdi-cloud-outline</v-icon>
                          <span class="section-title">External Configuration</span>
                        </div>

                        <div class="form-grid">
                          <v-text-field
                            id="add-tablename-external-dataIntegration"
                            label="Table Name"
                            v-model="requestDataIntegration.DataIntegrationName"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoDataIntegrationName')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-text-field>

                          <v-select
                            id="add-database-external-dataIntegration"
                            label="Database*"
                            :items="DDDatabase"
                            item-title="name"
                            item-value="id"
                            @update:model-value="onInputConnectionString()"
                            v-model="requestDataIntegration.Database"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoModel')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-select>
                        </div>

                        <v-text-field
                          id="add-connection-external-dataIntegration"
                          label="Connection String"
                          @input="onInputConnectionString()"
                          v-model="requestDataIntegration.ConnectionString"
                          :rules="[rules.required]"
                          variant="outlined"
                          density="comfortable"
                          class="modern-input full-width"
                        >
                          <template v-slot:append-inner>
                            <v-tooltip :text="$t('_InfoConnectionString')" location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                              </template>
                            </v-tooltip>
                          </template>
                        </v-text-field>

                        <div class="form-grid">
                          <v-text-field
                            id="add-schema-external-dataIntegration"
                            label="Schema"
                            @input="onInputSchema()"
                            v-model="requestDataIntegration.Schema"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoSchema')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-text-field>

                          <v-text-field
                            id="add-view-external-dataIntergration"
                            label="View"
                            v-model="requestDataIntegration.View"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoTable')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </div>

                        <!-- Effective Date Range -->
                        <div class="form-grid">
                          <div class="form-group">
                            <label class="input-label">Effective Start DateTime</label>
                            <VueDatePicker
                              v-model="requestDataIntegration.EffectiveStartDate"
                              placeholder="Select start date & time"
                              :enable-time-picker="true"
                              :format="'dd/MM/yyyy HH:mm'"
                              text-input
                              auto-apply
                              :max-date="requestDataIntegration.EffectiveEndDate"
                              :teleport="true"
                              class="custom-datetime-picker"
                              @update:model-value="onStartDateChange"
                            />
                          </div>

                          <div class="form-group">
                            <label class="input-label">Effective End DateTime</label>
                            <VueDatePicker
                              v-model="requestDataIntegration.EffectiveEndDate"
                              placeholder="Select end date & time"
                              :enable-time-picker="true"
                              :format="'dd/MM/yyyy HH:mm'"
                              text-input
                              auto-apply
                              :min-date="requestDataIntegration.EffectiveStartDate"
                              :teleport="true"
                              class="custom-datetime-picker"
                              @update:model-value="onEndDateChange"
                            />
                          </div>
                        </div>

                        <!-- External Columns -->
                        <div class="external-columns-section">
                          <div class="columns-header">
                            <h3 class="columns-title">Column Configuration</h3>
                            <v-btn id="add-column-external-dataIntegration" variant="outlined" color="primary" size="small" prepend-icon="mdi-plus" @click="AddColumn()" class="add-column-btn">
                              Add Column
                              <v-tooltip activator="parent" location="top"> เพิ่มเฉพาะ Column ที่ต้องใช้ (ไม่จำเป็นต้องใช้ทุฝ Column ที่มีอยู่ใน Table) </v-tooltip>
                            </v-btn>
                          </div>

                          <div class="external-columns-grid">
                            <v-card v-for="(item, index) in requestDataIntegration.Columns" :key="index" class="external-column-card" variant="outlined">
                              <v-card-text class="external-column-content">
                                <div class="external-column-header">
                                  <v-chip size="x-small" color="primary" variant="tonal">
                                    {{ index + 1 }}
                                  </v-chip>
                                  <v-btn
                                    :id="`add-deleteColumn-external-dataIntegration${index}`"
                                    icon
                                    variant="text"
                                    size="x-small"
                                    color="error"
                                    @click="DeleteAction(index)"
                                    class="delete-column-btn"
                                  >
                                    <v-icon size="16">mdi-close</v-icon>
                                  </v-btn>
                                </div>

                                <v-text-field
                                  :id="`add-columnname-external-dataIntegration-${index}`"
                                  :label="'Column'"
                                  v-model="item.name"
                                  variant="outlined"
                                  density="comfortable"
                                  class="external-column-input"
                                  :error="errorMessages.columns[index]?.error"
                                  :error-messages="errorMessages.columns[index]?.message"
                                ></v-text-field>

                                <!-- <v-checkbox
                                  :id="`add-checkbox-fuzzy-external-dataIntegration${index}`"
                                  v-model="item.fuzzy"
                                  @update:model-value="item.fuzzyBot = false"
                                  color="primary"
                                  density="comfortable"
                                  hide-details
                                  class="modern-checkbox"
                                >
                                  <template v-slot:label>
                                    <div class="checkbox-label">
                                      <span>Fuzzy</span>
                                      <v-tooltip :text="$t('_InfoFuzzy')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1" class="ml-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </v-checkbox> -->
                                <!-- <v-checkbox
                                  :id="`add-checkbox-fuzzy-external-dataIntegration${index}`"
                                  v-model="item.fuzzyBot"
                                  @update:model-value="item.fuzzy = false"
                                  color="primary"
                                  density="comfortable"
                                  hide-details
                                  class="modern-checkbox"
                                >
                                  <template v-slot:label>
                                    <div class="checkbox-label">
                                      <span>Fuzzy with bot</span>
                                      <v-tooltip :text="$t('_InfoFuzzyWithBot')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1" class="ml-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </v-select> -->
                                <div class="column-fields">
                                  <v-select
                                    :items="fuzzyOptions"
                                    item-title="text"
                                    item-value="value"
                                    variant="outlined"
                                    class="fuzzy-select"
                                    density="compact"
                                    hide-details
                                    @update:model-value="setFuzzyValue(item, $event)"
                                    :disabled="validateString(item)"
                                  >
                                    <!-- :disabled="type == 'I' && item.typeId != 'nvarchar'" -->
                                    <template v-slot:selection="{ item: selectedItem }">
                                      <div class="selection-content">
                                        <v-icon :color="getFuzzyColor(selectedItem.raw)" size="16" class="mr-2">
                                          {{ getFuzzyIcon(selectedItem.raw) }}
                                        </v-icon>
                                        <span class="selection-text">{{ selectedItem.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item: dropdownItem }">
                                      <v-list-item v-bind="props" class="fuzzy-list-item">
                                        <template v-slot:prepend>
                                          <v-icon :color="getFuzzyColor(dropdownItem.raw)" size="18">
                                            {{ getFuzzyIcon(dropdownItem.raw) }}
                                          </v-icon>
                                        </template>

                                        <v-list-item-subtitle class="fuzzy-item-subtitle">
                                          {{ dropdownItem.raw.description }}
                                        </v-list-item-subtitle>
                                      </v-list-item>
                                    </template>

                                    <template v-slot:label>
                                      <div class="label-content">
                                        <v-icon size="16" class="mr-2" color="primary">mdi-tune</v-icon>
                                        <span>Fuzzy Matching</span>
                                      </div>
                                    </template>
                                  </v-select>

                                  <div class="personal-info-wrapper">
                                    <div class="personal-info-container">
                                      <div class="personal-info-header">
                                        <v-tooltip location="top" max-width="300px">
                                          <template v-slot:activator="{ props }">
                                            <div class="personal-info-label" v-bind="props">
                                              <v-icon size="16" color="warning" class="mr-1">mdi-shield-account</v-icon>
                                              <span class="text-caption">
                                                Personal Info:
                                                <span :class="item.personalInformation ? 'status-on' : 'status-off'">
                                                  {{ item.personalInformation ? 'ON' : 'OFF' }}
                                                </span>
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ $t('_Personal_Info') }}</span>
                                        </v-tooltip>

                                        <v-switch
                                          v-model="item.personalInformation"
                                          inset
                                          density="compact"
                                          color="warning"
                                          hide-details
                                          class="personal-info-switch"
                                          :disabled="validateString(item)"
                                        ></v-switch>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <!-- Enhanced Actions -->
                  <div class="dialog-actions">
                    <div class="actions-content">
                      <div class="actions-left">
                        <v-tooltip text="Test Connection" location="top" v-if="requestDataIntegration.Type !== 'I'">
                          <template v-slot:activator="{ props }">
                            <v-btn id="button-test-connection-dataIntegration" variant="outlined" color="primary" @click="TestConnection()" class="dialog-action-btn test-btn" v-bind="props">
                              <v-icon start>mdi-connection</v-icon>
                              Test Connection
                            </v-btn>
                          </template>
                        </v-tooltip>
                        <!-- checkbox get all colums outline -->
                        <v-checkbox
                          id="checkbox-get-all-columns-dataIntegration"
                          v-model="chkAllColumns"
                          label="Get All Columns"
                          color="primary"
                          density="comfortable"
                          hide-details
                          class="modern-checkbox"
                          v-if="requestDataIntegration.Type !== 'I'"
                        ></v-checkbox>
                      </div>
                      <div class="actions-right">
                        <v-btn variant="outlined" color="grey-darken-1" @click="closeDialogAddDataIntegration" class="dialog-action-btn cancel-btn"> Cancel </v-btn>
                        <v-btn
                          v-if="canAdd"
                          variant="flat"
                          @click="requestDataIntegration.Type === 'I' ? ConfirmProcess('I') : ConfirmProcess('E')"
                          class="dialog-action-btn save-btn-add"
                          :disabled="!requestDataIntegration.DataIntegrationName"
                        >
                          <v-icon start>mdi-content-save</v-icon>
                          Save Configuration
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <!-- <v-card-actions class="modern-actions">
                    <v-spacer></v-spacer>
                    <v-btn
                      variant="text"
                      color="grey-darken-1"
                      @click="AddDataIntegration = false"
                      class="action-btn cancel-btn"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="success"
                      variant="flat"
                      @click="
                        requestDataIntegration.Type === 'I'
                          ? ConfirmProcess('I')
                          : ConfirmProcess('E')
                      "
                      class="action-btn save-btn"
                      :disabled="!requestDataIntegration.DataIntegrationName"
                    >
                      <v-icon start>mdi-content-save</v-icon>
                      Save Configuration
                    </v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server v-model:options="options" :items-per-page="itemsPerPage" :items-length="searchTotalTable" :items="dataTable" :headers="headers" :loading="loadingTable">
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.dataName }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">
                <div class="date-cell">
                  <div>{{ formatDateTime(item.effectiveStartDate).date }}</div>
                  <!-- <div class="time-text">{{ formatDateTime(item.effectiveStartDate).time }}</div> -->
                </div>
              </td>
              <td style="text-align: left">
                <div class="date-cell">
                  <div>{{ formatDateTime(item.effectiveEndDate).date }}</div>
                  <!-- <div class="time-text">{{ formatDateTime(item.effectiveEndDate).time }}</div> -->
                </div>
              </td>
              <td style="text-align: center">
                <v-chip :color="item.status ? '#F58468' : '#2ABF56'" size="small" class="status-chip">
                  <v-icon icon="mdi-circle-medium" start></v-icon>
                  <span style="color: black !important; font-size: 14px !important">{{ item.status || 'Active' }}</span>
                </v-chip>
              </td>
              <td style="text-align: center">
                <v-switch
                  :model-value="item.activeStatus !== false"
                  @update:model-value="toggleActive(item, $event)"
                  size="small"
                  density="compact"
                  inset
                  hide-details
                  :disabled="!canEdit"
                  class="toggle-switch"
                  :class="item.activeStatus ? 'on' : 'off'"
                ></v-switch>
              </td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center">
                  <div style="width: 35px; height: 35px; cursor: pointer" @click="Edit(item)">
                    <v-img v-if="canEdit" :src="editImgAction" alt="Edit Icon" height="30" width="30" aspect-ratio="1" />
                    <v-icon v-else color="primary" size="28">mdi-eye-outline</v-icon>
                  </div>
                  <div v-if="canDelete" class="trash-icon-wrapper" :class="{ 'is-disabled': btnDisableDelete(item) }">
                    <v-icon
                      @click="btnDisableDelete(item) ? null : Delete(item.id)"
                      :style="{ cursor: btnDisableDelete(item) ? 'not-allowed' : 'pointer' }"
                      :color="btnDisableDelete(item) ? 'grey-lighten-1' : 'red'"
                      size="30"
                    >mdi-trash-can-outline</v-icon>
                    <v-tooltip v-if="btnDisableDelete(item)" activator="parent" location="top">You can only delete items you created</v-tooltip>
                  </div>

                  <!-- <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable" @click="Edit(item)" class="action-btn edit-btn" icon>
                    <v-icon size="18">mdi-pencil-outline</v-icon>
                  </v-btn>
                  <div class="action-divider"></div>
                  <!-- Delete -->
                  <!-- <v-btn id="button-delete-uploadCSV" variant="text" density="comfortable" @click="Delete(item.id)" class="action-btn delete-btn" icon :disabled="btnDisableDelete(item)">
                    <v-icon size="18">mdi-delete-outline</v-icon>
                  </v-btn> -->
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- loading -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Filter Navigation Drawer -->
    <v-navigation-drawer v-model="filterDrawer" location="right" temporary scrim width="400" class="filter-drawer-fullpage">
      <v-card flat height="100%" class="filter-drawer-card">
        <v-card-title class="d-flex align-center justify-space-between pa-4">
          <div class="d-flex align-center">
            <img :src="drawerIcon" alt="Filter" class="drawer-icon mr-2" />
            <span class="text-h7 font-weight-bold">Filter</span>
          </div>
          <v-btn icon variant="text" @click="filterDrawer = false" size="small">
            <v-icon size="24" color="#903F98">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <hr style="border: none; border-top: 1px solid #ededed" class="mx-4" />
        <v-card-text class="pa-4">
          <div class="mb-1">
            <h4 class="filter-section-title">Status</h4>
            <v-checkbox
              v-model="statusFilters.all"
              label="All"
              density="compact"
              hide-details
              class="mb-1 ml-1 custom-checkbox"
              :color="statusFilters.all ? '#76237E' : '#C9C9C9'"
              @click="handleStatusFilterClick('all')"
            ></v-checkbox>
            <v-checkbox
              v-model="statusFilters.active"
              label="Active"
              density="compact"
              hide-details
              class="mb-1 ml-1 custom-checkbox"
              :color="statusFilters.active ? '#76237E' : '#C9C9C9'"
              @click="handleStatusFilterClick('active')"
            ></v-checkbox>
            <v-checkbox
              v-model="statusFilters.inactive"
              label="Inactive"
              density="compact"
              hide-details
              class="mb-1 ml-1 custom-checkbox"
              :color="statusFilters.inactive ? '#76237E' : '#C9C9C9'"
              @click="handleStatusFilterClick('inactive')"
            ></v-checkbox>
          </div>

          <hr style="border: none; border-top: 1px solid #ededed" class="my-4" />

          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Effective Start Date</h4>
            <VueDatePicker
              v-model="effectiveStartDate"
              placeholder="Select start date & time"
              :enable-time-picker="true"
              :format="'dd/MM/yyyy HH:mm'"
              text-input
              auto-apply
              :max-date="effectiveEndDate"
              :teleport="true"
              class="custom-datetime-picker"
              @update:model-value="onFilterStartDateChange"
            />
          </div>

          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Effective End Date</h4>
            <VueDatePicker
              v-model="effectiveEndDate"
              placeholder="Select end date & time"
              :enable-time-picker="true"
              :format="'dd/MM/yyyy HH:mm'"
              text-input
              auto-apply
              :min-date="effectiveStartDate"
              :teleport="true"
              class="custom-datetime-picker"
              @update:model-value="onFilterEndDateChange"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import dateUtils from '../plugins/date-utils';
import DragDropFile from '@/components/DragDropFile.vue';
import ExcelJS from 'exceljs';
import moment from 'moment';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import EditIcon from '@/assets/images/edit-icon-new.svg';
import FilterIcon from '@/assets/images/mage_filter.svg';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: 'DataIntegration',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround', 'Username', 'RoleId'],
  components: { DragDropFile, VueDatePicker },
  mixins: [checkPermissionTwo],
  data: () => ({
    updatingStatusFilters: false, // Flag to prevent infinite loops in status filter watcher
    searchDebounceTimer: null, // Timer for debouncing search input
    drawerIcon: FilterIcon,
    searchText: null,
    filterDrawer: false, // Filter drawer data
    statusFilters: {
      all: true,
      active: false,
      inactive: false,
    },
    effectiveStartDate: null,
    effectiveEndDate: null,
    editImgAction: EditIcon,
    addStartDateFlag: false, // For add dialog start date picker
    addEndDateFlag: false, // For add dialog end date picker

    //.......

    today: null,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    searchDataIntegrationName: null,
    AddDataIntegration: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    loadingTable: false,
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    files: [],
    uploadedFiles: [],
    chkAllColumns: false,
    requestDataIntegration: {
      entity: null,
      DataIntegrationName: null,
      ConnectionString: '',
      Schema: '',
      View: '',
      Columns: [{ name: '', typeId: 'nvarchar', fuzzy: false, fuzzyBot: false }],
      Type: 'I',
      Database: '',
      EffectiveStartDate: null,
      EffectiveEndDate: null,
    },
    DataRowUpload: [],
    DDDataType: [
      {
        id: 'nvarchar',
        name: 'nvarchar',
      },
      {
        id: 'int',
        name: 'int',
      },
      {
        id: 'float',
        name: 'float',
      },
      {
        id: 'datetime',
        name: 'datetime',
      },
      {
        id: 'bit',
        name: 'bit',
      },
    ],
    DDDatabase: [
      {
        id: '1',
        name: 'SQL Server',
      },
      {
        id: '2',
        name: 'Oracle',
      },
      {
        id: '3',
        name: 'Postgresql',
      },
      {
        id: '4',
        name: 'Mysql',
      },
      {
        id: '5',
        name: 'Snowflake',
      },
    ],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    defaultFuzzy: 'none', // Default fuzzy option
    fuzzyOptions: [
      {
        text: 'None',
        value: 'none',
        description: 'No fuzzy matching applied',
        icon: 'mdi-close-circle-outline',
        color: 'grey',
      },
      {
        text: 'Fuzzy Search',
        value: 'fuzzy',
        description: 'Enable approximate text matching for this column',
        icon: 'mdi-magnify',
        color: 'primary',
      },
      {
        text: 'Fuzzy with Bot',
        value: 'fuzzyBot',
        description: 'AI-powered smart matching with enhanced accuracy',
        icon: 'mdi-robot',
        color: 'success',
      },
    ],
    errorMessages: {
      columns: [
        {
          error: false,
          message: '',
        },
      ],
    },
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('DataIntegration');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('DataIntegration'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('DataIntegration'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('DataIntegration'));
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('DataIntegration'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('DataIntegration'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('DataIntegration'),
      }
    },
    headers() {
      return [
        {
          title: 'No.',
          align: 'center',
          sortable: false,
          width: '80px',
          minWidth: '60px',
        },
        {
          title: 'Table Name',
          value: 'Name',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '200px',
        },
        {
          title: 'Create by',
          value: 'CreateBy',
          align: 'left',
          sortable: true,
          width: '150px',
          minWidth: '130px',
        },
        {
          title: 'Effective Start Date',
          value: 'EffectiveStartDate',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '200px',
        },
        {
          title: 'Effective End Date',
          value: 'EffectiveEndDate',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '190px',
        },
        {
          title: 'Status',
          value: 'Status',
          align: 'center',
          sortable: true,
          width: '120px',
          minWidth: '100px',
        },
        {
          title: 'Active',
          value: 'Active',
          align: 'center',
          sortable: false,
          width: '100px',
          minWidth: '80px',
        },
        {
          title: 'Action',
          align: 'center',
          sortable: false,
          width: '120px',
          minWidth: '100px',
        },
      ];
    },

  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    searchDataIntegrationName: {
      handler() {
        this.debouncedSearch();
      },
    },
    AddDataIntegration: {
      handler(newValue) {
        if (!newValue) {
          // Reset form when dialog closes
          this.addStartDateFlag = false;
          this.addEndDateFlag = false;
        }
      },
    },

    // Filter watchers for datetime fields
    effectiveStartDate: {
      handler(newStartDate) {
        if (this.effectiveEndDate && newStartDate > this.effectiveEndDate) {
          this.$swal.fire({
            icon: 'error',
            title: 'Invalid Date Range',
            text: 'Start date cannot be after end date',
            timer: 2000,
          });
          this.effectiveStartDate = null;
          return;
        }
        this.Search();
      },
    },

    effectiveEndDate: {
      handler(newEndDate) {
        if (this.effectiveStartDate && newEndDate < this.effectiveStartDate) {
          this.$swal.fire({
            icon: 'error',
            title: 'Invalid Date Range',
            text: 'End date cannot be before start date',
            timer: 2000,
          });
          this.effectiveEndDate = null;
          return;
        }
        this.Search();
      },
    },
  },
  methods: {
    // Debounced search method to prevent excessive API calls
    debouncedSearch(searchValue) {
      // Clear existing timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      // Set new timer with 400ms delay
      this.searchDebounceTimer = setTimeout(() => {
        this.Search();
      }, 400);
    },
    formatDate(date) {
      if (!date) return null;
      // Format date to YYYY-MM-DD format
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatDateTime(dateTime) {
      if (!dateTime) return { date: null, time: null };

      // Create date object - JavaScript automatically converts UTC to local time
      const d = new Date(dateTime);

      // Format date as DD/MM/YYYY (local time)
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      const date = `${day}/${month}/${year}`;

      // Format time as HH:MM:SS (local time)
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      const time = `${hours}:${minutes}:${seconds}`;

      return { date, time };
    },
    formatDateTimeForAPI(dateTime) {
      if (!dateTime) return null;

      // If it's already a string in correct format, return as is
      if (typeof dateTime === 'string') {
        return dateTime;
      }

      // If it's a Date object, format it as UTC ISO string for API
      const d = new Date(dateTime);
      return d.toISOString();
    },
    onStartDateChange(date) {
      // VueDatePicker handles the date/time automatically
      console.log('Start date changed:', date);
    },
    onEndDateChange(date) {
      // VueDatePicker handles the date/time automatically
      console.log('End date changed:', date);
    },
    onFilterStartDateChange(date) {
      // Handle filter start date change
      console.log('Filter start date changed:', date);
      this.Search();
    },
    onFilterEndDateChange(date) {
      // Handle filter end date change
      console.log('Filter end date changed:', date);
      this.Search();
    },
    applyFilters() {
      this.Search();
    },

    handleStatusFilterClick(clickedFilter) {
      // Handle mutual exclusivity for status filters
      if (clickedFilter === 'all') {
        this.statusFilters = {
          all: !this.statusFilters.all,
          active: false,
          inactive: false,
        };
      } else if (clickedFilter === 'active') {
        this.statusFilters = {
          all: false,
          active: !this.statusFilters.active,
          inactive: false,
        };
      } else if (clickedFilter === 'inactive') {
        this.statusFilters = {
          all: false,
          active: false,
          inactive: !this.statusFilters.inactive,
        };
      }
      console.log('Status filter clicked:', clickedFilter, this.statusFilters);
      this.Search();
    },
    toggleFilterDrawer() {
      this.filterDrawer = !this.filterDrawer;
    },
    closeDialogAddDataIntegration() {
      this.AddDataIntegration = false;
      this.errorMessages.columns = [{ error: false, message: '' }];
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    validateString(item) {
      if (this.requestDataIntegration.Type === 'E') {
        const stringTypes = ['nvarchar', 'text', 'varchar', 'varchar2', 'char', 'nchar', 'TEXT', 'VARCHAR2', 'CHAR', 'NCHAR', 'NVARCHAR2'];
        return !stringTypes.includes(item.typeId);
      }
    },
    setFuzzyValue(item, value) {
      // Reset all fuzzy options
      item.fuzzy = false;
      item.fuzzyBot = false;

      // Set the selected option
      if (value === 'fuzzy') {
        item.fuzzy = true;
      } else if (value === 'fuzzyBot') {
        item.fuzzyBot = true;
      }
    },
    toggleActive(item, isActive) {
      // Handle the toggle active state with API call
      const self = this;
      const requestData = {
        ID: item.id,
        ActiveStatus: isActive,
      };

      self.$call.UpdateDataIntegrationActiveStatus(
        requestData,
        (res) => {
          if (res.status === 0) {
            item.activeStatus = isActive;
            self.$swal.fire({
              title: 'Success!',
              text: `Status updated successfully`,
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
            });
            console.log(`Toggle active for ${item.dataName}:`, isActive);
          } else {
            self.$swal.fire({
              title: 'Error!',
              text: res.message || 'Failed to update status',
              icon: 'error',
            });
            // Revert the toggle if API fails
            item.activeStatus = !isActive;
          }
        },
        (error) => {
          console.error('Error updating active status:', error);
          self.$swal.fire({
            title: 'Error!',
            text: 'Failed to update status',
            icon: 'error',
          });
          // Revert the toggle if API fails
          item.activeStatus = !isActive;
        }
      );
    },
    getFuzzyColor(itemOrOption) {
      if (itemOrOption.color) return itemOrOption.color; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return 'primary';
      if (itemOrOption.fuzzyBot) return 'success';
      return 'grey';
    },
    getFuzzyIcon(itemOrOption) {
      if (itemOrOption.icon) return itemOrOption.icon; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return 'mdi-magnify';
      if (itemOrOption.fuzzyBot) return 'mdi-robot';
      return 'mdi-close-circle-outline';
    },
    Get() {
      let self = this;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let activeStatus = null;
      if (self.statusFilters.active) {
        activeStatus = true;
      } else if (self.statusFilters.inactive) {
        activeStatus = false;
      }

      let searchValue = self.searchDataIntegrationName && self.searchDataIntegrationName.trim()
        ? self.searchDataIntegrationName.trim()
        : null;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        DataName: searchValue,
        CreateBy: searchValue,
        ActiveStatus: activeStatus,
        EffectiveStartDateFrom: self.formatDateTimeForAPI(self.effectiveStartDate),
        EffectiveStartDateTo: null,
        EffectiveEndDateFrom: null,
        EffectiveEndDateTo: self.formatDateTimeForAPI(self.effectiveEndDate),
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableDataIntegration(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    triggerFileUpload() {
      // เรียฝ method click ของ DragDropFile component
      if (this.$refs.dragDropRef) {
        // หาปุ่ม upload ใน DragDropFile component ๝ละคลิฝ
        const uploadButton = this.$refs.dragDropRef.$el.querySelector('input[type="file"]');
        if (uploadButton) {
          this.errorMessages.columns.push({ error: false, message: '' });
          uploadButton.click();
        }
      }
    },
    Search() {
      let self = this;
      self.isSearch = true;
      if (self.options.page !== 1) {
        self.options.page = 1;
        return;
      }
      self.Get();
    },
    Save() {
      let self = this;
      let tempCheckColumns = [];
      let headers = [];
      let listindexnamefuzzy = [];
      let columnData = [];
      let spaceText = false;
      self.requestDataIntegration.Columns.forEach((item, index) => {
        // validate Column ' abc defg '
        const splitText = item.name.split(' ');
        if (this.errorMessages.columns[index]) {
          this.errorMessages.columns[index].error = false;
          this.errorMessages.columns[index].message = '';
        }

        if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
          if (!this.errorMessages.columns[index]) {
            this.errorMessages.columns[index] = { error: false, message: '' };
          }

          this.errorMessages.columns[index].error = true;
          this.errorMessages.columns[index].message = 'Column name cannot have leading or trailing spaces!';
          spaceText = true;
        }

        if (item.name !== null && item.name !== undefined && item.name !== '' && item.typeId !== null && item.typeId !== undefined && item.typeId !== '') {
          tempCheckColumns.push(item);
          headers.push(item.name);
        }
        if (item.fuzzy == true || item.fuzzyBot == true) {
          let index = headers.indexOf(item.name);
          listindexnamefuzzy.push(index);
        }
      });

      if (spaceText) {
        return;
      }

      if (self.ValidateColumns(headers, columnData)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('_duplicateColumn'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      if (!self.requestDataIntegration.DataIntegrationName || tempCheckColumns.length < 1 || self.requestDataIntegration.Columns.length != tempCheckColumns.length) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warningFillAll'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      self.requestDataIntegration.Columns = tempCheckColumns;
      let chkValidateLimitFuzzy = self.ValidateLimitFuzzy(headers, listindexnamefuzzy);
      if (chkValidateLimitFuzzy != null) {
        self.$swal.fire({
          icon: 'warning',
          title: chkValidateLimitFuzzy,
          showConfirmButton: true,
        });
        return;
      }
      self.dialog = true;

      // Format datetime fields for API if they exist
      if (self.requestDataIntegration.EffectiveStartDate) {
        self.requestDataIntegration.EffectiveStartDate = self.formatDateTimeForAPI(self.requestDataIntegration.EffectiveStartDate);
      }
      if (self.requestDataIntegration.EffectiveEndDate) {
        self.requestDataIntegration.EffectiveEndDate = self.formatDateTimeForAPI(self.requestDataIntegration.EffectiveEndDate);
      }

      let temp = {
        ReqData: self.requestDataIntegration,
        uploaded_file: self.requestDataIntegration.entity,
      };
      try {
        self.$call.AddDataIntegration_Table(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.Get();
              self.SaveData(dataResponse.data);
            } else {
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
              self.dialog = false;
            }
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    SaveData(id) {
      let self = this;
      self.dialog = true;
      let temp = {
        id,
        uploaded_file: self.requestDataIntegration.entity,
        deleteAll: false,
      };
      try {
        self.$call.AddDataIntegration_Data(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.AddDataIntegration = false;
              self.requestDataIntegration.DataIntegrationName = null;
              self.requestDataIntegration.EffectiveStartDate = null;
              self.requestDataIntegration.EffectiveEndDate = null;
              // Reset date picker flags
              self.addStartDateFlag = false;
              self.addEndDateFlag = false;
              // self.Get();
            } else {
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    Delete(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('ConfirmDeletion'),
            text: this.$t('confirmDeletionTableName'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteDataIntegration(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                  } else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: 'error',
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t('gotIt'),
                      confirmButtonColor: '#d33',
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
              self.Get();
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Add() {
      let self = this;
      self.AddDataIntegration = true;
      self.uploadedFiles = [];
      self.requestDataIntegration.Columns = [];
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: 'DataIntegrationDetail',
        query: {
          id: item.id,
        },
      });
    },
    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      this.today = dd + '/' + mm + '/' + yyyy;
    },
    // async AutoRefresh() {
    //   let self = this;
    //   let death_waiting = true;
    //   do {
    //     for (let value of self.dataTable) {
    //       if (value.inProcess < value.inProcessMax && !value.isError) {
    //         self.ReFreshGet();
    //         death_waiting = true;
    //         break;
    //       } else {
    //         death_waiting = false;
    //       }
    //     }
    //     if (window.location.pathname != '/VectorManagement') {
    //       death_waiting = false;
    //     }
    //     console.log('Wait for 5 seconds!');
    //     await new Promise((resolve) => setTimeout(resolve, 5000));
    //   } while (death_waiting);
    // },
    getColumnData(dataRows) {
      const dataTypes = [];
      dataRows[0].forEach((_, colIndex) => {
        // เฝ็บข้อมูลชนิดต่างๆ ที่พบในคอลัมน์
        let hasString = false;
        let hasFloat = false;
        let hasInteger = false;
        let hasBoolean = false;
        let hasDate = false;

        // วนลูปเช็คข้อมูลทั้งหมดในคอลัมน์
        for (let i = 0; i < dataRows.length; i++) {
          const value = dataRows[i][colIndex];
          if (value instanceof Date && !isNaN(value)) {
            hasDate = true;
          } else if (typeof value === 'boolean') {
            hasBoolean = true;
          } else if (Number.isInteger(value)) {
            hasInteger = true;
          } else if (typeof value === 'number') {
            hasFloat = true;
          } else if (typeof value === 'string') {
            // ตรวจสอบว่า string นี้เป็นตัวเลขหรือไม่
            const numValue = Number(value);
            if (!isNaN(numValue) && isFinite(numValue)) {
              if (Number.isInteger(numValue)) {
                hasInteger = true;
              } else {
                hasFloat = true;
              }
            } else {
              hasString = true;
            }
          } else {
            hasString = true;
          }
        }

        // ฝำหนด data type ตามลำดับความเหมาะสม
        let detectedType = 'nvarchar'; // ค่าเริ่มต้น

        if (hasString) {
          detectedType = 'nvarchar'; // ถ้ามี string เลยเป็น nvarchar
        } else if (hasDate) {
          detectedType = 'datetime'; // ถ้ามี date
        } else if (hasFloat) {
          detectedType = 'float'; // ถ้ามี float (รวมถึงฝรณี int+float)
        } else if (hasInteger) {
          detectedType = 'int'; // ถ้ามี๝ต่ integer
        } else if (hasBoolean) {
          detectedType = 'bit'; // ถ้ามี๝ต่ boolean
        }
        dataTypes.push(detectedType);
      });
      return dataTypes;
    },
    processUpload(e) {
      let self = this;
      this.files = e;
      if (this.files.length == 0) {
        this.requestDataIntegration.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      const file = this.files[0];
      reader.onload = async (event) => {
        const buffer = event.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        // Get the first worksheet
        const worksheet = workbook.getWorksheet(1);
        if (!worksheet) {
          self.$swal.fire({
            icon: 'error',
            title: 'No worksheet found in the Excel file',
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }

        // Extract data from the worksheet
        const jsonData = [];
        const headers = [];

        // Get headers from the first row
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          headers.push(cell.value);
        });
        jsonData.push(headers);

        // Get data from remaining rows
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          const rowData = [];
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            rowData[colNumber - 1] = cell.value;
          });

          // Ensure rowData has the same length as headers
          while (rowData.length < headers.length) {
            rowData.push('');
          }

          jsonData.push(rowData);
        });

        self.DataRowUpload = jsonData.slice(1);
        const columnData = self.getColumnData(self.DataRowUpload);

        if (self.ValidateColumns(headers, columnData)) {
          self.$swal.fire({
            icon: 'error',
            title: self.$t('_duplicateColumn'),
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          this.MapData(self.files);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    ValidateLimitFuzzy(headers, listindexnamefuzzy) {
      let self = this;
      for (let j = 0; j < listindexnamefuzzy.length; j++) {
        let indexcol = listindexnamefuzzy[j];
        for (let i = 0; i < self.DataRowUpload.length; i++) {
          let tmpdata = self.DataRowUpload[i][indexcol];
          if (tmpdata.length > 800) {
            return 'The data in column ' + headers[indexcol] + ', row ' + (i + 2) + ' exceeds the limit of 800 characters.';
          }
        }
      }
      return null;
    },
    ValidateColumns(columns, columnData) {
      let self = this;

      const uniqueColumns = [...new Set(columns)];
      if (uniqueColumns.length !== columns.length) {
        return true; //มี Header ซ้ำ
      } else {
        self.requestDataIntegration.Columns = [];
        self.requestDataIntegration.Columns = columns.map((item, index) => ({
          name: item,
          typeId: columnData[index],
          fuzzy: false,
          fuzzyBot: false,
        }));
        return false;
      }
    },
    MapData(files) {
      const formDataDoc = new FormData();
      formDataDoc.append('uploaded_file', files[0]);
      //console.log(files[0]);
      this.uploadedFiles = files;
      this.requestDataIntegration.entity = formDataDoc;
    },
    ConfirmProcess(type) {
      let self = this;
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('ConfirmDataAddition'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (type == 'I') {
              self.totalTable = self.totalTable + 1;
              self.Save();
            } else if (type == 'E') {
              self.totalTable = self.totalTable + 1;
              self.AddDataIntegrationConnection();
            }
          }
        });
    },
    TestConnection() {
      let self = this;
      if (!self.requestDataIntegration.ConnectionString) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please fill in information Connection String!',
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      if (self.chkAllColumns) {
        if (self.requestDataIntegration.Schema == '' || self.requestDataIntegration.Schema == null) {
          alert('Please fill in information Schema!');
          return;
        }
        if (self.requestDataIntegration.View == '' || self.requestDataIntegration.View == null) {
          alert('Please fill in information View!');
          return;
        }
      }
      self.dialog = true;

      if (!self.chkAllColumns) {
        if (self.requestDataIntegration.Columns.some((col) => col.name.trim() === '')) {
          self.$swal.fire({
            icon: 'warning',
            title: 'Please fill in all column names!',
            showConfirmButton: false,
            timer: 2500,
          });
          self.dialog = false;
          return;
        }
      }
      let cols = self.requestDataIntegration.Columns.map((col) => col.name);
      let temp = {
        ConnectionString: self.requestDataIntegration.ConnectionString,
        Schema: self.requestDataIntegration.Schema,
        View: self.requestDataIntegration.View,
        Database: self.requestDataIntegration.Database,
        chkAllColumns: self.chkAllColumns,
        ColumnChecklist: cols,
      };
      self.$call.TestConnection(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.GetALLColumnByTestConnection(dataResponse.data.columns);
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.data.message,
              showConfirmButton: true,
              confirmButtonText: 'Okay',
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    AddColumn() {
      let self = this;

      let temp = {
        name: '',
        fuzzy: false,
        fuzzyBot: false,
      };
      self.requestDataIntegration.Columns.push(temp);
      self.errorMessages.columns.push({ error: false, message: '' });
    },
    GetALLColumnByTestConnection(listColumns) {
      let self = this;
      self.requestDataIntegration.Columns = [];
      listColumns.forEach((columnName) => {
        let temp = {
          name: columnName.name, // นำ columnName ใส่ใน temp.name
          // dataType : columnName.dataType, // นำ columnName.dataType ใส่ใน temp.dataType
          typeId: columnName.dataType, // นำ columnName.dataType ใส่ใน temp.typeId
          fuzzy: false,
          fuzzyBot: false,
        };
        self.requestDataIntegration.Columns.push(temp);
      });
    },
    DeleteAction(index) {
      let self = this;
      if (index > -1 && index < self.requestDataIntegration.Columns.length) {
        self.requestDataIntegration.Columns.splice(index, 1);
        self.errorMessages.columns.splice(index, 1);
      }
    },
    ClearPopupAddDataIntegration() {
      let self = this;
      self.requestDataIntegration.entity = null;
      self.requestDataIntegration.DataIntegrationName = null;
      self.requestDataIntegration.ConnectionString = '';
      self.requestDataIntegration.Schema = '';
      self.requestDataIntegration.View = '';
      self.requestDataIntegration.Columns = [{ name: '', fuzzy: false, fuzzyBot: false }];
      self.requestDataIntegration.Type = 'I';
      self.requestDataIntegration.Database = '';
      self.requestDataIntegration.EffectiveStartDate = null;
      self.requestDataIntegration.EffectiveEndDate = null;
    },
    closeDialog() {
      // Reset all form data
      this.requestDataIntegration = {
        entity: null,
        DataIntegrationName: null,
        ConnectionString: '',
        Schema: '',
        View: '',
        Columns: [{ name: '', typeId: 'nvarchar', fuzzy: false, fuzzyBot: false }],
        Type: 'I',
        Database: '',
        EffectiveStartDate: null,
        EffectiveEndDate: null,
      };

      // Reset date picker flags
      this.addStartDateFlag = false;
      this.addEndDateFlag = false;

      // Reset other form states
      this.uploadedFiles = [];
      this.chkAllColumns = false;

      // Close the dialog
      this.AddDataIntegration = false;
    },
    ClearPopupWhenChange() {
      let self = this;
      self.requestDataIntegration.entity = null;
      self.requestDataIntegration.DataIntegrationName = null;
      self.requestDataIntegration.ConnectionString = '';
      self.requestDataIntegration.Schema = '';
      self.requestDataIntegration.View = '';
      self.requestDataIntegration.Columns = [{ name: '', fuzzy: false, fuzzyBot: false }];
      self.requestDataIntegration.EffectiveStartDate = null;
      self.requestDataIntegration.EffectiveEndDate = null;

      // Reset date picker flags
      self.addStartDateFlag = false;
      self.addEndDateFlag = false;
      self.errorMessages.columns = [{ error: false, message: '' }];
    },
    AddDataIntegrationConnection() {
      let self = this;
      let tempCheckColumns = [];
      let headers = [];
      let columnData = [];
      let spaceText = false;
      self.requestDataIntegration.Columns.forEach((item,index) => {
        // Ensure errorMessages.columns array has enough elements
        if (!this.errorMessages.columns[index]) {
          this.errorMessages.columns[index] = { error: false, message: '' };
        }
        
        this.errorMessages.columns[index].error = false;
        this.errorMessages.columns[index].message = '';
        
        // Check if item.name exists and is a string before splitting
        if (item.name && typeof item.name === 'string') {
          const splitText = item.name.split(' ');
          if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
            this.errorMessages.columns[index].error = true;
            this.errorMessages.columns[index].message = 'Column name cannot have leading or trailing spaces!';
            spaceText = true;
          }
        }
        
        if (item.name !== null && item.name !== undefined && item.name !== '') {
          tempCheckColumns.push(item);
          headers.push(item.name);
        }
      });

      if (spaceText) {
        return;
      }

      if (self.ValidateColumns(headers, columnData)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('_duplicateColumn'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      if (
        !self.requestDataIntegration.DataIntegrationName ||
        !self.requestDataIntegration.ConnectionString ||
        !self.requestDataIntegration.Schema ||
        !self.requestDataIntegration.View ||
        !self.requestDataIntegration.Database ||
        tempCheckColumns.length < 1
      ) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      // Validate datetime fields for External integration
      if (self.requestDataIntegration.EffectiveStartDate && self.requestDataIntegration.EffectiveEndDate) {
        const startDate = new Date(self.requestDataIntegration.EffectiveStartDate);
        const endDate = new Date(self.requestDataIntegration.EffectiveEndDate);

        if (startDate >= endDate) {
          self.$swal.fire({
            icon: 'warning',
            title: 'Effective Start Date must be before Effective End Date!',
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }
      }
      self.dialog = true;
      self.requestDataIntegration.Columns = tempCheckColumns;

      // Format datetime fields for API if they exist
      if (self.requestDataIntegration.EffectiveStartDate) {
        self.requestDataIntegration.EffectiveStartDate = self.formatDateTimeForAPI(self.requestDataIntegration.EffectiveStartDate);
      }
      if (self.requestDataIntegration.EffectiveEndDate) {
        self.requestDataIntegration.EffectiveEndDate = self.formatDateTimeForAPI(self.requestDataIntegration.EffectiveEndDate);
      }

      self.$call.AddDataIntegrationConnection(
        self.requestDataIntegration,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.AddDataIntegration = false;
            self.ClearPopupAddDataIntegration();
            self.Get();
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2500,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.AddDataIntegration = false;
          console.error(errorResource);
        }
      );
    },
    setDefault(item) {
      item.fuzzy = false;
      item.fuzzyBot = false;
    },
    onInputSchema() {
      let self = this;
      if (self.requestDataIntegration.Database == '5') {
        const cs = self.requestDataIntegration.ConnectionString || '';
        const newSchema = (self.requestDataIntegration.Schema || '').trim();
        let updatedCS;

        // ถ้ามี key schema อยู่๝ล้ว ให้ replace ค่า
        if (/(^|;)schema=[^;]*/i.test(cs)) {
          updatedCS = cs.replace(/(^|;)schema=[^;]*/i, `$1schema=${newSchema}`);
        } else {
          updatedCS = cs ? `${cs.replace(/;$/, '')};schema=${newSchema}` : `schema=${newSchema}`;
        }

        self.requestDataIntegration.ConnectionString = updatedCS;
      }
    },
    onInputConnectionString() {
      let self = this;
      if (self.requestDataIntegration.Database == '5') {
        const cs = self.requestDataIntegration.ConnectionString || '';
        const schema = this.extractSchema(cs);
        if (schema) {
          self.requestDataIntegration.Schema = schema;
        }
      }
    },
    extractSchema(connectionString) {
      const match = connectionString.match(/(?:^|;)schema=([^;]+)/i);
      return match ? match[1].trim() : '';
    },
  },
  mounted() {
    this.GetDate();
  },
  beforeDestroy() {
    // Clean up debounce timer to prevent memory leaks
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* Table improvements */
:deep(.v-data-table) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em !important;
}

/* Search panel improvements */
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Dialog improvements */
:deep(.v-dialog .v-card) {
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: center;
    min-width: auto;
  }

  .control-btn {
    flex: 1;
  }
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.control-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

::v-deep.UploadFile .NoDragDrop button.v-btn {
  margin: 0px !important;
}

.middle4 {
  position: absolute;
  right: 3px;
  top: 18px;
  transform: translateY(-50%);
  opacity: 0;
  transition: 0.2s ease;
}

.Card-Action {
  padding: 0 5px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  position: relative;
  margin-bottom: 5px;
}

.Card-Action:hover .middle4 {
  opacity: 1;
}
/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 12px;
  align-self: center;
  border-radius: 1px;
}

.dialog-container :deep(.v-overlay__content) {
  margin: 24px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}

.modern-card {
  border-radius: 20px !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.04);
  background: #ffffff;
}

/* Enhanced Header */
.modern-header {
  padding: 24px 24px 16px 24px;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02) 0%, rgba(25, 118, 210, 0.01) 100%);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(25, 118, 210, 0.1);
  border-radius: 12px;
}

.header-text {
  flex: 1;
}

.title-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
  line-height: 1.2;
}

.subtitle-text {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  margin: 4px 0 0 0;
  line-height: 1.2;
}

.close-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.04);
}

.header-divider {
  margin: 0 24px;
  opacity: 0.1;
}

/* Content Section */
.modern-content {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.section-container {
  margin-bottom: 32px;
}

.section-container:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.section-icon {
  opacity: 0.8;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}

/* Radio Group Modern */
.radio-group-modern {
  margin-top: 8px;
}

.radio-options {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.radio-option {
  flex: none;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.radio-icon {
  opacity: 0.7;
}

/* Configuration Sections */
.config-section {
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group-large {
  grid-column: 1 / -1;
}

.full-width {
  grid-column: 1 / -1;
}

.upload-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.modern-upload {
  flex: 1;
}

.upload-section {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.upload-container {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  border: 2px dashed rgba(25, 118, 210, 0.3);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02) 0%, rgba(25, 118, 210, 0.01) 100%);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(25, 118, 210, 0.05) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-area:hover {
  border-color: rgba(25, 118, 210, 0.5);
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.02) 100%);
  /* transform: translateY(-2px); */
  box-shadow: 0 6px 15px rgba(25, 118, 210, 0.15);
}

.upload-area:hover::before {
  opacity: 1;
}

/* Main Upload Button */
.upload-main-btn {
  position: relative;
  z-index: 2;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: 0 24px !important;
  height: 48px !important;
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.25) !important;
  transition: all 0.3s ease !important;
}

.upload-main-btn:hover {
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.35) !important;
  transform: translateY(-1px);
}

.upload-main-btn:active {
  transform: translateY(0);
}

.upload-text {
  font-size: 1rem;
  font-weight: 600;
}

/* Upload Info Section */
.upload-info {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.upload-description {
  display: flex;
  align-items: center;
  gap: 4px;
}

.upload-hint {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
}

.upload-help-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.upload-help-btn:hover {
  opacity: 1;
  background: rgba(25, 118, 210, 0.1);
}

/* Uploaded File Info */
.uploaded-file-info {
  position: relative;
  z-index: 2;
  animation: fadeInUp 0.3s ease;
}

.file-chip {
  font-weight: 500 !important;
  max-width: 280px;
}

.file-chip :deep(.v-chip__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Hidden Upload Component */
.hidden-upload {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-area {
    padding: 24px 16px;
    margin: 0 16px;
  }

  .upload-main-btn {
    height: 44px !important;
    padding: 0 20px !important;
  }

  .upload-text {
    font-size: 0.9rem;
  }

  .upload-info {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .upload-hint {
    font-size: 0.8rem;
  }
}

/* Loading State */
.upload-main-btn:disabled {
  opacity: 0.6;
  transform: none !important;
  box-shadow: none !important;
}

.upload-main-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

/* Focus States */
.upload-main-btn:focus-visible {
  outline: 2px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

.upload-help-btn:focus-visible {
  outline: 2px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

/* Animation for file upload success */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hover effects for better UX */
.upload-area:hover .upload-main-btn {
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.3) !important;
}

.upload-area:hover .upload-hint {
  color: rgba(25, 118, 210, 0.8);
}

.upload-info-icon {
  position: absolute;
  top: -8px;
  right: -8px;
}

/* Modern Inputs */
.modern-input {
  background: rgba(0, 0, 0, 0.01);
}

.modern-input :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.info-icon {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
}

/* Columns Section */
.columns-section {
  margin-top: 32px;
}

.columns-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.columns-title {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
}

.columns-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.column-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.01);
}

.column-card:hover {
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.column-content {
  padding: 20px;
}

.column-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.column-input {
  background: rgba(255, 255, 255, 0.8);
}

.column-options {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.modern-checkbox {
  flex: none;
}

.modern-checkbox :deep(.v-selection-control) {
  min-height: auto;
}

/* External Columns */
.external-columns-section {
  margin-top: 24px;
}

.add-column-btn {
  border-radius: 10px !important;
  font-weight: 500;
}

.external-columns-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}

.external-column-card {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.01);
  width: 100%;
}

.external-column-card:hover {
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.external-column-content {
  padding: 16px;
}

.external-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.delete-column-btn {
  opacity: 0.6;
  transition: all 0.2s ease;
}

.delete-column-btn:hover {
  opacity: 1;
  background: rgba(244, 67, 54, 0.1);
}

.external-column-input {
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.8);
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-weight: 500;
}

/* Actions */
/* .modern-actions {
  padding: 16px 24px 24px 24px;
  background: rgba(0, 0, 0, 0.01);
}

.cancel-btn {
  padding: 0 15px;
  margin-right: 15px;
}

.cancel-btn:hover {
  background: rgba(0, 0, 0, 0.04);
} */

/* .save-btn {
  padding: 0 15px;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25);
}

.save-btn:hover {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.35);
  transform: translateY(-1px);
}

.save-btn:disabled {
  opacity: 0.5;
  transform: none;
  box-shadow: none;
} */

/* Responsive Design */
@media (max-width: 768px) {
  .modern-header {
    padding: 20px 16px 12px 16px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    width: 40px;
    height: 40px;
  }

  .title-text {
    font-size: 1.25rem;
  }

  .modern-content {
    padding: 16px;
    max-height: 70vh;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .column-fields {
    grid-template-columns: 1fr;
  }

  .external-columns-grid {
    grid-template-columns: 1fr;
  }

  .radio-options {
    flex-direction: column;
    gap: 12px;
  }

  .column-options {
    flex-direction: column;
    gap: 8px;
  }

  .modern-actions {
    padding: 12px 16px 20px 16px;
    flex-direction: column;
    gap: 12px;
  }

  .action-btn {
    width: 100%;
  }
}

/* Smooth Scrollbar */
.modern-content::-webkit-scrollbar {
  width: 6px;
}

.modern-content::-webkit-scrollbar-track {
  background: transparent;
}

.modern-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.modern-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

/* personal info */
.personal-info-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 8px;
}

.personal-info-container {
  background-color: #fffbf2;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  padding: 4px 12px;
  width: 100%;
  transition: all 0.2s ease;
}
.personal-info-container:hover {
  background-color: #fff8e5;
  border-color: #ffe8a1;
}

.personal-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.personal-info-label {
  display: flex;
  align-items: center;
  cursor: help;
}

.personal-info-switch {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.personal-info-switch :deep(.v-switch__track) {
  opacity: 0.4;
}

.status-on {
  font-weight: 700;
  color: #ff9800;
}

/* Data Table Styling */
.date-cell {
  text-align: left;
}

.time-text {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
}

.status-chip {
  font-weight: 500;
  text-transform: capitalize;
}

::v-deep.toggle-switch.v-switch--inset .v-switch__thumb {
  height: 26px;
  width: 28px;
  transform: none !important;
}

/* Custom inset switch styling */
::v-deep.toggle-switch.v-switch--inset .v-switch__track {
  width: 55px !important;
  height: 30px !important;
  background-color: #c2c2c2 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  border: none !important;
  border-radius: 50px !important;
  min-width: none;
}

.action-group {
  background: none;
  display: flex;
  align-items: center;
  gap: 14px;
}

.action-divider {
  width: 1px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
}

.action-btn {
  min-width: 32px;
  border-radius: 6px;
}

.edit-btn:hover {
  background-color: rgba(25, 118, 210, 0.08);
  color: #1976d2;
}

.delete-btn:hover {
  background-color: rgba(211, 47, 47, 0.08);
  color: #d32f2f;
}

.status-off {
  font-weight: 500;
  color: #757575;
}
.page-title {
  font-weight: 600;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.87);
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 48px;
}
/* Custom Search Field Styling */
.custom-search-field {
  height: 48px !important;
}

.custom-search-field :deep(.v-field) {
  border-radius: 16px 16px !important;
  height: 48px !important;
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline__start),
.custom-search-field :deep(.v-field__outline__end) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__input) {
  display: flex !important;
  align-items: center !important;
  min-height: 48px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.custom-search-field :deep(.v-field__prepend-inner) {
  display: flex !important;
  align-items: center !important;
  padding-left: 5px !important;
}

.custom-search-field :deep(.v-input__control) {
  height: 48px !important;
}

.custom-search-field :deep(.v-field__field) {
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-document-btn {
  color: #ffff;
  text-transform: none;
  box-shadow: 0 2px 4px rgba(80, 72, 151, 0.3);
  border-radius: 16px !important;
  height: 48px !important;
  min-width: 170px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: linear-gradient(90deg, #504897 0%, #4b2667 100%);
}

.custom-document-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(80, 72, 151, 0.4);
}

.filter-btn {
  height: 48px;
  border-radius: 50% !important;
  box-shadow: 0 2px 4px rgba(75, 40, 105, 0.3);
  transition: all 0.2s ease;
}

.filter-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(75, 40, 105, 0.4);
}

.filter-drawer-fullpage {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  height: 100vh !important;
  z-index: 1999 !important;
  border-radius: 16px 0 0 16px;
}
.filter-drawer-card {
  border-radius: 16px 0 0 16px;
}

.v-navigation-drawer__scrim {
  background-color: rgba(0, 0, 0, 0.9) !important;
  z-index: 1997 !important;
}

/* Filter Drawer Styling */
.drawer-icon {
  width: 24px;
  height: 24px;
}
.filter-section-title {
  color: #000000;
  font-size: 16px;
  font-weight: 700;
}
/* Custom Date Picker Styling */
.custom-date-picker {
  margin-bottom: 8px !important;
}

.custom-date-picker :deep(.v-field) {
  border-radius: 48px !important;
  border: 1px solid #c9c9c9 !important;
  background: white !important;
  transition: all 0.2s ease !important;
}

.custom-date-picker :deep(.v-field__outline) {
  display: none !important;
}

/* DateTime Picker Styling */
.datetime-picker-card {
  max-width: 350px;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

.time-picker-section {
  background-color: #fafafa;
}

.time-picker-section .v-select {
  background-color: white;
}

.time-picker-section .v-select :deep(.v-field) {
  border-radius: 8px;
}

.time-picker-section .text-subtitle-2 {
  color: rgba(0, 0, 0, 0.7);
  font-weight: 600;
}

.datetime-picker-card :deep(.v-date-picker) {
  border-radius: 12px 12px 0 0;
}

.datetime-picker-card :deep(.v-date-picker-header) {
  padding: 16px;
}

.datetime-picker-card :deep(.v-btn) {
  text-transform: none;
  font-weight: 500;
}

.datetime-picker-card .v-card-actions {
  padding: 12px 16px;
  background-color: white;
}

.custom-date-picker :deep(.v-field__input) {
  padding: 12px 16px !important;
  min-height: 48px !important;
  color: #999 !important;
  font-size: 14px !important;
}

.custom-date-picker :deep(.v-field__append-inner) {
  padding-right: 16px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-date-picker :deep(.v-field__append-inner .v-icon) {
  opacity: 1 !important;
  cursor: pointer !important;
}

/* Hover state for date picker */
.custom-date-picker:hover :deep(.v-field) {
  border-color: #903f98 !important;
}

/* Focus state for date picker */
.custom-date-picker :deep(.v-field--focused) {
  border-color: #903f98 !important;
  box-shadow: 0 0 0 2px rgba(144, 63, 152, 0.1) !important;
}

::v-deep .v-table .v-table__wrapper > table > thead > tr > th {
  background: #f5f5f5 !important;
  font-weight: 600 !important;
  color: #000000 !important;
}
::v-deep .v-table .v-table__wrapper > table > thead > tr > th:first-child {
  border-top-left-radius: 16px !important;
}
::v-deep .v-table .v-table__wrapper > table > thead > tr > th:last-child {
  border-top-right-radius: 16px !important;
}
.custom-rounded-table {
  border: 1px solid #f5f5f5 !important;
  border-radius: 16px !important;
}

::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__thumb {
  background-color: #4e3982 !important;
}
::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__track {
  background-color: #ffffff !important;
  border: 1px solid #4e3982 !important;
}

/* Disabled trash icon — visually convey it can't be clicked */
.trash-icon-wrapper.is-disabled {
  opacity: 0.5;
  pointer-events: auto;
}
.trash-icon-wrapper.is-disabled .v-icon {
  cursor: not-allowed !important;
}
</style>
